<app-error-card
  title="401 Unauthorized"
  message="You must be signed in to view this page."
>
  <a class="btn btn-primary" routerLink="/login">Sign in</a>
</app-error-card>
